import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import {connect} from "react-redux";

function mapStateToProps(state) {
  return {
    currentAccount: state.accounts.currentAccount,
    currentUser: state.currentUser,
    inspect: state.inspect,
    currentSlateView: state.slateViews.currentSlateView,
    newSlateViewType: state.slateViews.newSlateViewType,
  };
}
export default withRouter(withTranslation()(connect(mapStateToProps)(Breadcrumbs)));

